/**
 * スクロール時に実行するクラスのインターフェース、的なもの
 */
export default class ScrollRegister {
  constructor() {
    // スクロールイベント時に操作するオブジェクトたちをいれておく配列
    this.items    = []
  }

  /**
   * スクロール開始時に呼ばれる
   */
  onScrollStart() {}

  /**
   * スクロール終了時時に呼ばれる
   */
  onScrollEnd() {}
}


// WEBPACK FOOTER //
// ./src/assets/js/motion/ScrollRegister.js